import {Component, OnInit, ViewChild} from "@angular/core";
import {PHONE_MASK} from "../../helpers/format-helpers";
import {MatHorizontalStepper} from "@angular/material/stepper";
import {MatSnackBar} from "@angular/material/snack-bar";
import {TranslateService} from "@ngx-translate/core";
import {AccountDeletionService} from "../services/account-deletion.service";
import {
  AccountDeletionConfirmModel,
  AccountDeletionRequestCodeModel
} from "../../models/account-deletion-request-code-model";
import {AccountDeletionCodeResultModel} from "../../models/account-deletion-code-result-model";
import {timer} from 'rxjs';
import * as moment from 'moment';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-account-deletion',
  templateUrl: './account-deletion.component.html',
  styleUrls: ['./account-deletion.component.css']
})
export class AccountDeletionComponent implements OnInit {
  phoneMask = PHONE_MASK;

  ticks = 0;
  timer;
  accountDeletionForm: FormGroup;
  personalDataForm: FormGroup;
  smsForm: FormGroup;
  dataForm: FormGroup;


  newEmailVisible = false;

  showErrorChangeMail: boolean;
  errorMessageChangeMail: string;


  maxDob = this.getMaxDateOfBirth();
  minDob = this.getMinDateOfBirth();


  phone: string;
  newPhoneToSet: string;
  dob: Date;
  smsSent: boolean;
  deletionRequestDetails: AccountDeletionCodeResultModel;
  isSendingCode = false;

  @ViewChild(MatHorizontalStepper, {static: false}) stepper: MatHorizontalStepper;
  firstName: string|null;
  requestId: string|null;
  confirmed = false;
  isConfirming =false;
  notAllCardsClosed = false;
  unpaidInvoices = false;

  constructor(
    private formBuilder: FormBuilder,
    private accountDeletionService: AccountDeletionService,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
  ) { }






  ngOnInit() {
    this.personalDataForm = this.formBuilder.group({
      phone: ['', [Validators.required]],
      dob: ['', [Validators.required]],

    });
    this.smsForm = this.formBuilder.group({ code:  ['', [Validators.required]]});
    this.dataForm = this.formBuilder.group({
      deleteDataRequest: false,
    });

    this.accountDeletionForm = this.formBuilder.group({
      token: this.personalDataForm,
      sms:  this.smsForm,
      data: this.dataForm,
    });
  }

  sendPhoneDob(value: any) {
    this.accountDeletionService.requestDeletion(value.phone, value.dob).subscribe(result => {
      this.phone = result.maskedPhone;
      this.stepper.next();
      // this.sendPhoneCode();
    });
  }

  sendPhoneCode() {
    this.isSendingCode = true;
    this.smsSent = true;

    let dob = moment(this.personalDataForm.value.dob).toDate();
    let phone = parseInt(this.personalDataForm.value.phone); // remove the plus

    this.accountDeletionService.requestDeletionVerificationCode(phone, dob).subscribe(result => {
      this.isSendingCode = false;
      this.timer = timer(30, 1000);
      const subscription = this.timer.subscribe(t => {
        this.ticks = 30 - t;
        if (this.ticks == 0) {
          subscription.unsubscribe();
        }
      });
    }, error => {
      this.isSendingCode = false;
    });
  }

  verifyPhoneCode(value: any) {

    let dob = moment(this.personalDataForm.value.dob).toDate();
    let phone = parseInt(this.personalDataForm.value.phone); // remove the plus
    let code = this.smsForm.value.code;

    const model = new AccountDeletionRequestCodeModel();
    model.dob = dob;
    model.phone = phone;
    model.code = code;

    this.accountDeletionService.verifyDeletionVerificationCode(model).subscribe(result => {
      this.stepper.next();
    });
  }

  sendConfirmation(value: any) {

    let dob = moment(this.personalDataForm.value.dob).toDate();
    let phone = parseInt(this.personalDataForm.value.phone); // remove the plus
    let code = this.smsForm.value.code;
    let deleteData = this.dataForm.value.deleteDataRequest;

    const model = new AccountDeletionConfirmModel();
    model.dob = dob;
    model.phone = phone;
    model.code = code;
    model.deleteDataRequest = deleteData;

    this.isConfirming = true;

    this.accountDeletionService.confirmDeletion(model).subscribe(result => {
      this.isConfirming = false;
      this.confirmed = true;
      this.requestId = result.requestId;
      this.firstName = result.firstName
    }, error => {
      this.isConfirming = false;

    if( error.error === 'not_all_cards_closed' ){
      this.notAllCardsClosed = true;
    }

    });
  }



  getMaxDateOfBirth() {
    // This is used to prevent persons under 18 years from creating orders
    // There is an additional control in the API, consider it when changing the minimal person age.
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() - 18);
    maxDate.setHours(0,0,0,0);
    return maxDate;
  }

  getMinDateOfBirth() {
    // MS
    // This is used to prevent persons from entering birth dates that are over 100 years ago
    // There is an additional control in the API, consider it when changing the maximum person age.
    const minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 100);
    minDate.setHours(0,0,0,0);
    return minDate;
  }

  getTick() {
    return this.ticks != 0 ? ' (' + this.ticks + ')' : '';
  }

}
